import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = '/api/v1/bank-category'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },
  add(bankCategory) {
    return http.post(`${resource}`, bankCategory)
  },
  get(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  update(bankCategory, uuid) {
    return http.post(`${resource}/${uuid}?_method=PATCH`, bankCategory)
  },
  destroy(uuid) {
    return http.delete(`${resource}/${uuid}`)
  },
}
